$(document).ready(function(){

	var AutoPlay = true;
    var ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf('safari') != -1) {
        if (ua.indexOf('chrome') > -1) {
            //alert("1") // Chrome
        } else {
            AutoPlay = false;
        }
    }


	// Player Setting
    //$radioURL = "stream.885fm.org/latinalt";
	$radioURL = "stream.885fm.org/2";
	$radioPort = "";
	var ShowAlbumCover = true; // For this you need an Amazon API Key / API_SECRET_KEY, if you don't have set this to false, the player will show only your Radio Logo

	var usedMemLimit = true;
	var usedMemLimitVal = 500; // If Broswer usedMemory becomes more then 100 MB, player refresh the page.
	///////////////////////////////
	$("#stopBtn").hide();
	$('#coverHolder').append('<img src="/assets/framework/logo-126x126.jpg" width="126"></img>');
	// Player Panel default Text, this can be RadioName or like "Press Play" , etc...
	$('#currentSong').text("88.5 FM HD3 - Latin Alternative");
	// IE8 doesn't support EQ Animation
	if($.browser.msie == true){
        if($.browser.version<9){
            $("#eqHolder").hide();
        }
	}
	///////////////////////////////
	soundManager.useFlashBlock = true;
	soundManager.url = '/SoundManager/swf/'; // required: path to directory containing SM2 SWF files
	soundManager.flashVersion = 9;
	soundManager.preferFlash = false;
	soundManager.useHighPerformance = true;
	soundManager.flash9Options.usePeakData = true;
	soundManager.debugMode = false;
	///////////////////////////////
	// Player start Volume 50
	$("#amount").text(50);
	$("#amount").hide();
	$("#stopBtn").hide();
	$('#slider').slider({
		orientation: "horizontal",
		range: "min",
		min: 0,
		max: 100,
		step: 5,
		value:50,
		slide: function(event, ui) {
		$("#amount").text(ui.value); // this will show current volume as Text, made invisible via CSS
		soundManager.setVolume('radioStream',ui.value);
	}
	});
	///////////////////////////////
	var myRadio;
	var resultContainer = $('#coverHolder');
	var goDown = true;
	var goUp = false;
	var songMem = new Array();
	var saveFirstSong = true;
	var historyIS = false;
	var musicLink;
    var nowPlaying = "";
	///////////////////////////////
	$("#playBtn").click(function(){
		startRadio();
	})
	//
	if(AutoPlay == true){
		startRadio();
	}
	//
	function startRadio(){
		resultContainer.empty();
		$('#coverHolder').append('<img id="" src="/assets/framework/progress.gif"></img>');
		$("#stopBtn").fadeIn();
		$("#playBtn").hide();

		// OG META TAGS
		//$("meta[property='og:audio']").attr("content", 'https://'+$radioURL+'/stream.mp3');
        $("meta[property='og:audio']").attr("content", 'https://'+$radioURL);

		soundManager.onready(function(){
			myRadio = soundManager.createSound({
				id: 'radioStream',
				//url: 'https://'+$radioURL+'/stream.mp3',
                url: 'https://'+$radioURL,
				stream: true,
				volume: $("#amount").text(),
				//usePeakData: true,     // [Flash 9 only] whether or not to show peak data (no notable CPU cost)
				usePolicyFile: true,
				//type: 'audio/mpeg',
			});
			//
			myRadio.options.whileplaying = function() {
				var peakleft = this.peakData.left*40;
				var peakright = this.peakData.right*40;
				//console.log(peakleft,peakright)
				if(peakleft != 0){
					$("#eqOne").css('width', peakleft);
					$("#eqTwo").css('width', peakright);
					$("#eqThree").css('width', peakleft);
					$("#eqFour").css('width', peakright);
					$("#eqFive").css('width', peakleft);
					$("#eqSix").css('width', peakright);
				}
			}
			myRadio.play();


			loadSongInfo();
		});;
		loadSongInfoInterval = setInterval(loadSongInfo, 20000);
	}


	function loadSongInfo() {
        var url = window.location.href;
        var arr = url.split("/");
        url = arr[0] + "//" + arr[2] + '/ajax/Program/PlayerCurrentSongInfo';

		$.ajaxSetup({ cache: false });
		$.ajax({
			type: "GET",
			url: url,
			dataType: "json",
			success: function(data) {
				if(data.id == songMem[0]) {
					//console.log("Same Song");
				} else {
					var titleDisplay = '';
					//console.log("Song Changed!");
					saveFirstSong = true;

					// TITLE
					if(data.title) {
						titleDisplay = data.title;

						if(data.artist) {
							titleDisplay = data.artist + " - " + titleDisplay;
						}

						if($('#currentSong').text() != titleDisplay) {
							$('#currentSong').hide();
                            $('#currentTitle').hide();

							//$('#currentSong').text(titleDisplay);
                            $('#currentSong').text(data.artist);
                            $('#currentTitle').text(data.title);
							$('#currentSong').fadeIn();
                            $('#currentTitle').fadeIn();



                            //$('#currentSong').text(data.artist);



							// HTML TITLE TAG
							$("head title").text('Now Playing - ' + titleDisplay + ' - 88.5 FM/HD1');

							// OG META TAG
							$("meta[property='og:title']").attr("content", data.title);
							$("meta[property='og:audio:title']").attr("content", data.title);
						}

					}

					// IMAGE
					if(ShowAlbumCover != false && data.image_src) {
						var image_src = data.image_src;
					} else {
						var image_src = '/assets/framework/bilingualsounds-logo-square2.png';
					}
					$('#coverHolder').empty();
					$('#coverHolder').hide();
					$('#coverHolder').append('<img src="' + image_src + '" width="125"></img>');
					$('#coverHolder').fadeIn();
					$("#coverGlass").fadeIn();

					// OG META TAGS
					if($("meta[property='og:image']").attr("content") != image_src) {
						$("meta[property='og:image']").attr("content", image_src);
					}

					// BUY
					if($('#purchase_container').length) {
						if($('#purchase_container').attr('rel') != data.id) {
							$('#purchase_container').hide();
							$('#purchase_container').html(data.buy);
							$('#purchase_container').fadeIn();
						}
					}


				}

				// Song history
				if(saveFirstSong){
					saveFirstSong = false;
					songMem[0] = data.id;
                    //console.log("Load History");

					//todo: load history from cache
                    loadHistory(songMem[0]);

				}
			}
		});
	}

    function loadHistory($id){

        $.ajax({
            type: "GET",
            url: "/ajax/Program/PlayerSongHistory/"+$id,
            success: function(data) {

            	$("#history_container").html(data)
                return false;
            }
        });
        return false;
    }

	/* deprecated */
	function grabRadioInfo(){
		// Calculate UsedMemory, this will be usefull for Developers
		$('#usedMemory').text((soundManager.getMemoryUse()/1024/1024).toFixed(2));
		if((soundManager.getMemoryUse()/1024/1024).toFixed(2) > usedMemLimitVal){
			if(usedMemLimit){
				window.location = "index.html";
			}
		}
		// Grab Current Song Title
		$.ajaxSetup({ cache: false });
			var dataString = {
			'currentradiourl' : $radioURL,
			'currentradioport' : $radioPort,
		};
		$.ajax({
			type: "POST",
			url: "songTitle.php",
			data: dataString,
			success: function(data) {
				var newCurrentSong = data.replace("</body></html>", "");

				if($('#currentSong').text() != newCurrentSong) {
					$('#currentSong').hide();
					$('#currentSong').text(newCurrentSong);
					 $('#currentSong').fadeIn();

					// HTML TITLE TAG
					$("head title").text($('#currentSong').text());

					// OG META TAG
					$("meta[property='og:title']").attr("content", $('#currentSong').text());
					$("meta[property='og:audio:title']").attr("content", $('#currentSong').text());

					if(saveFirstSong){
						saveFirstSong = false;
						songMem[0] = newCurrentSong;
						grabInfo();
					}

					// we save grabed Song Title into Array and compare it in every few seconds if changed or not, if yes then try to grab SongHistory and AlbumCover
					// This is very important to prevent unnecessary requests, specially for Amazon server.
					if(data.replace("</body></html>", "") == songMem[0]){
						//console.log("Same Song");
					} else {
						//console.log("Song Changed!");
						grabInfo();
						saveFirstSong = true;
					}
				}
			}
		});

		return false;
	}
	// Grab SongHistory and AlbumCover
	function grabInfo(){
		var dataString = {
			'currentradiourl' : $radioURL,
			'currentradioport' : $radioPort,
		};
		$.ajax({
			type: "POST",
			url: "/listen/history/",
			data: dataString,
			success: function(data) {
				historyIS = true;
				$('#songHistoryText').html(data);
				var dataString = {
					'name' : $('#currentSong').text()
				};
				if(($('#currentSong').text() != "") && ShowAlbumCover != false){
					$.ajax({
					type: "POST",
					url: "search.php",
					data: dataString,
					success: function(data) {
						if(data != ""){
							//console.log("Result Found");
							resultContainer.empty();
							resultContainer.hide();
							var curCover = data.slice(data.indexOf('<img'));
							resultContainer.append(curCover);
							resultContainer.fadeIn();
							musicLink = data.substring(0, data.indexOf('<img'));
							$("#coverGlass").fadeIn();

							// OG META TAGS
							$("meta[property='og:image']").attr("content", resultContainer.find('img').attr('src'));

						}
						if(data == ""){
							 // If first search Result comes empty, now Try a new search only with Singer Name
							 //console.log("no Result, Try Again!");
							 var curTitle = $('#currentSong').text();
							 //curTitle = curTitle.substring(curTitle.indexOf('-')).replace("-", "")+"-"+curTitle.substring(0,curTitle.indexOf('-'));
							 curTitle = curTitle.substring(0,curTitle.indexOf('-'))+" mp3";
							 var dataString = {
							 'name' : curTitle,
							};
							$.ajax({
							type: "POST",
							url: "search.php",
							data: dataString,
							success: function(data) {
								resultContainer.empty();
								resultContainer.hide();
								var curCover = data.slice(data.indexOf('<img'));
								resultContainer.append(curCover);
								resultContainer.fadeIn();
								musicLink = data.substring(0, data.indexOf('<img'));
								$("#coverGlass").fadeIn();

								// OG META TAGS
								$("meta[property='og:image']").attr("content", resultContainer.find('img').attr('src'));
							}
							});
							return false;
						}
						//console.log(data);
					}
					}); // search.php call
				} else {
					$('#coverHolder').empty();
					$('#coverHolder').append('<img src="/assets/framework/logo-125.png" width="125"></img>');
					// OG META TAGS
					$("meta[property='og:image']").attr("content", 'https://www.bilingualsounds.org/assets/framework/noCover.jpg');
				}
				return false;
			}
		});
		return false;
	}
	/*
	$('#coverGlass').click(function(){
		if(musicLink != undefined){
			window.open(musicLink);
			return false;
		}
    })
	*/
	// Player Stop Button
	$("#stopBtn").click(function(){
		// reset EQ
		$("#eqOne").css('width', '0px');
		$("#eqTwo").css('width', '0px');
		$("#eqThree").css('width', '0px');
		$("#eqFour").css('width', '0px');
		$("#eqFive").css('width', '0px');
		$("#eqSix").css('width', '0px');
		//
		myRadio.stop();
		clearInterval(loadSongInfoInterval);
		soundManager.unload('radioStream');
		$("#stopBtn").fadeOut();
		$("#playBtn").fadeIn();
		songMem[0] = songMem[1] = "";
		//$('#coverHolder').empty();
		//$('#coverHolder').append('<img src="/assets/framework/noCover.jpg"></img>');
		$('#currentSong').text("88.5 FM HD3 - Bilingual Sounds");
	})

	$("#muteBtn").click(function(){
		soundManager.setVolume('radioStream', 0);
		$('#slider').slider("option", "value", 0);
		$("#amount").text(0);

		// reset EQ
		$("#eqOne").css('width', '0px');
		$("#eqTwo").css('width', '0px');
		$("#eqThree").css('width', '0px');
		$("#eqFour").css('width', '0px');
		$("#eqFive").css('width', '0px');
		$("#eqSix").css('width', '0px');
	});

	$("#songHistoryBtn").hover(mouseOver, mouseOut);

	function mouseOver(){
		$("#songHistoryBtn").css('background-image','url("./images/SongHistoryOver.png")');
	}

	function mouseOut(){
		$("#songHistoryBtn").css('background-image','url("./images/SongHistoryNormal.png")');
	}
	// Change DIV Top to visualize SongHistoryPanel Open/Close
	$('#songHistoryBtn').click(function() {
		  if(historyIS){
		  if(goDown){
			  goDown = false;
			  $('#songHistoryBackground').animate({
			  top: '-15px',
			  }, {
				duration: 300,
				specialEasing: {
				  width: 'linear',
				  height: 'easeOutBounce'
				},
				complete: function() {
				  goUp = true;
				}
			  });
		  }
		  if(goUp){
			  goUp = false;
			  $('#songHistoryBackground').animate({
			  top: '-227px',
			  }, {
				duration: 300,
				specialEasing: {
				  width: 'linear',
				  height: 'easeOutBounce'
				},
				complete: function() {
					goDown = true;
				}
			  });
			}
		}
	});


	// Login managment
	$('#screen,#cancel').click(function(e) {
		closeLogin();
	});

	$('#Account').on('click', '#Logout', function(e) {
		e.preventDefault();
		window.opener.location='/member/logout/';
		$('#Account').html('You are logged out.');
		setTimeout(function() {
			$('#Account').html('');
		}, 1500);

	});


	$('#Form_LoginForm').submit(function(e) {
		e.preventDefault();

		$.ajax({
			type: 'POST',
			url: $(this).attr('action'),
			data: $(this).serialize(),
			dataType: 'json',
			success: function(data) {
				if(data.code > 0) {
					var timeout = 1500;

					window.opener.location.reload();

					$('#message').html(data.message).removeClass('error');

					if(data.member_name) {
						$('#Account').html('Welcome, ' + data.member_name + ' | <a href="#Logout" id="Logout">Logout</a>');
					}

					if(data.code > 1) {
						timeout = 3000;
					}
					setTimeout(closeLogin, timeout);
				} else {
					$('#message').html(data.message).addClass('error');
				}
			},
			error: function(jqXHR, textStatus, errorThrown) {
				console.log(textStatus + ", " + errorThrown);
				$('#message').text('Error: Please try again later.').addClass('error');
			}
		});
	});
});

	function showLogin() {
		$('#screen').show();
		$('#loginContainer').fadeIn('fast', function() {
			if($('#Form_LoginForm_Email').length) {
				$('#Form_LoginForm_Email').focus();
			}
		});
	}

	function closeLogin() {
		$('#loginContainer').hide();
		$('#screen').hide();
		$('#message').text('').removeClass('error');
	}
